var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paragraghFullhtml"},[(this.fullHtml.js_code != null)?[_c('div',{domProps:{"innerHTML":_vm._s(this.fullHtml.value)}}),_c('div',{model:{value:(_vm.jsGen),callback:function ($$v) {_vm.jsGen=$$v},expression:"jsGen"}})]:[_c('div',{domProps:{"innerHTML":_vm._s(this.fullHtml.value)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }